/** Strip HTML to plain text (browser). Safe for display; not a full XSS sanitizer for untrusted HTML. */
export function htmlToPlainText(html) {
  if (!html || typeof document === "undefined") return "";
  const div = document.createElement("div");
  div.innerHTML = html;
  return (div.textContent || div.innerText || "").trim();
}

export function escapeHtmlText(s) {
  return String(s ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** Unwrap `<a>` and markdown links so syndicated copy never drives users off-site. */
function stripAnchorsFromHtmlClient(html) {
  let out = String(html ?? "");
  let prev;
  let guard = 0;
  do {
    prev = out;
    out = out.replace(/<a\b[^>]*>([\s\S]*?)<\/a>/gi, "$1");
    guard += 1;
  } while (out !== prev && guard < 64);
  out = out.replace(/\[([^\]]+)\]\([^)]+\)/g, "$1");
  return out;
}

/** Strip common XSS vectors before `dangerouslySetInnerHTML` (API is trusted-ish; still harden). */
export function sanitizePublicArticleHtml(html) {
  let out = String(html ?? "").trim();
  if (!out) return "";
  out = out.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, "");
  out = out.replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, "");
  out = out.replace(/<iframe\b[^>]*>[\s\S]*?<\/iframe>/gi, "");
  out = out.replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, "");
  out = out.replace(/\s(href|src)\s*=\s*["']?\s*javascript:/gi, ' data-removed="1"');
  out = stripAnchorsFromHtmlClient(out);
  return out;
}

const normPlain = (s) =>
  String(s ?? "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase();

/**
 * Remove a leading H1/H2 (or a single-line P) that repeats the page headline
 * so the hero title is not echoed again in the body.
 */
export function stripLeadingDuplicateHeadline(html, title) {
  if (typeof document === "undefined") return String(html ?? "").trim();
  const t = normPlain(title);
  if (!t) return String(html ?? "").trim();
  const div = document.createElement("div");
  div.innerHTML = String(html ?? "").trim();
  let guard = 0;
  while (guard++ < 8 && div.firstElementChild) {
    const el = div.firstElementChild;
    const tag = el.tagName.toLowerCase();
    if (tag === "h1" || tag === "h2") {
      if (normPlain(el.textContent) === t) {
        el.remove();
        continue;
      }
      break;
    }
    if (tag === "p" && normPlain(el.textContent) === t) {
      el.remove();
      continue;
    }
    break;
  }
  return div.innerHTML.trim();
}